import { render, staticRenderFns } from "./TabelaPropostasProponente.vue?vue&type=template&id=6d06adb0&"
import script from "./TabelaPropostasProponente.vue?vue&type=script&lang=js&"
export * from "./TabelaPropostasProponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports